import {Box, Paper, Stack, Typography} from '@mui/material';
import MarkdownContentRenderer from '../../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';

export interface AdminStudyEditorPreviewProps {
  content: string;
}

export default function AdminStudyEditorPreview({content}: AdminStudyEditorPreviewProps) {
  return (
    <Paper
      sx={{
        p: 3,
        bgcolor: 'grey.50',
        height: '100%',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <Stack spacing={2} sx={{flex: 1, display: 'flex', flexDirection: 'column'}}>
        <Typography variant="subtitle2" sx={{fontWeight: 600}}>
          Preview
        </Typography>

        <Box sx={{flex: 1, overflow: 'auto'}}>
          <MarkdownContentRenderer content={content} />
        </Box>
      </Stack>
    </Paper>
  );
}
